import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/apps";
import * as tourActions from "../actions/tour";

import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import Loader from "react-loader-advanced";

import AppFrame from "./Appframe/AppFrame";
import AppCreator from "./playbook/AppCreator";
import Title from "../components/common/Title";

import layout from "../styles/layout";
import { Mixpanel } from "../mixpanel";

class CreateNewApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appInfo: {},
      appType: "Standard",
      appId: -1,
      isUserOrgMember: props.user.userInfo.hasOrg && !props.user.isOrgAdmin,
      isCreated: false,
      showConfirmationDialogue: false,

      width: 0,
      height: 0,
    };

    this.createApp = this.createApp.bind(this);
    this.confirmationDialogue = this.confirmationDialogue.bind(this);
    this.closeDialogue = this.closeDialogue.bind(this);
    this.updateAppInfo = this.updateAppInfo.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillMount() {
    // Clear on focus app ID
    this.props.selectApp(-1);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillReceiveProps(nextProps) {
    // Pop up confirmation dialogue when app has been created in the server
    if (nextProps.selectedAppId > 0) {
      // App has been Created
      this.setState({
        appId: nextProps.selectedAppId,
        isCreated: true,
        showConfirmationDialogue: true,
      });
    }
  }

  createApp() {
    // create app
    let appInfo = this.state.appInfo;
    if (this.state.isUserOrgMember) {
      // for org members, some of the fields are default by the Organization
      let orgData = this.props.organization.orgInfoData.orgData;
      appInfo.coverUrl = orgData.defaultCoverUrl;
      appInfo.logoImageUrl = orgData.defaultLogoUrl;
    }
    this.props.createNewApp(this.props.userId, appInfo.templateId, appInfo);
    alert("Channel created!");

    Mixpanel.track("New Channel", {
      Email: this.props.user.email,
      "Channel Name": appInfo.appName,
      "Channel Type": appInfo.appType,
      Platform: "Web",
    });

    if (this.props.apps.appInfos.length < 1) {
      this.props.showTour();
    }

    let link = `/view-channels/${this.props.userId}`;
    this.props.history.push(link);
  }

  confirmationDialogue() {
    let linkToNext = `/view-channels/`;
    if (this.state.appInfo.appType === "LibraryOnly") {
      linkToNext = `/update-app-template/${this.state.appId}`;
    }
    const actions = [
      <FlatButton
        label="What’s Next?"
        primary={true}
        onClick={() => {
          if (this.state.appInfo.appType !== "LibraryOnly") {
            this.props.showTour();
          }
          this.props.history.push(linkToNext);
        }}
      />,
    ];

    return (
      <Dialog
        title="Your Channel is published!"
        actions={actions}
        modal={true}
        open={this.state.showConfirmationDialogue}
        onRequestClose={this.closeDialogue}
      />
    );
  }

  closeDialogue() {
    this.setState({
      showConfirmationDialogue: false,
    });
  }

  updateAppInfo(appInfo) {
    this.setState({
      appInfo,
    });
  }

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }

    return (
      <AppFrame
        auth={this.props.auth}
        header="Create New Channel"
        whiteLabelSettings={this.props.whiteLabelSettings}
        optionsType="createApp"
      >
        <div style={layout.common.page}>
          <Loader show={this.props.apps.isLoading} message={"Loading..."}>
            <AppCreator
              userId={this.props.userId}
              isOrgMember={this.state.isUserOrgMember}
              onChange={this.updateAppInfo}
              onSubmit={this.createApp}
            />
            {this.confirmationDialogue()}
          </Loader>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, organization, whiteLabelSettings }) {
  return {
    user,
    userId: user.userId,
    userProfile: user.profile,
    selectedAppId: apps.selectedAppId,
    apps,
    organization,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...tourActions, ...actionCreators }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewApp);



// WEBPACK FOOTER //
// ./src/layout/CreateNewApp.js